import { render, staticRenderFns } from "./AgendaTipologieListPage.vue?vue&type=template&id=c0173e0c&scoped=true"
import script from "./AgendaTipologieListPage.vue?vue&type=script&lang=js"
export * from "./AgendaTipologieListPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaTipologieListPage.vue?vue&type=style&index=0&id=c0173e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0173e0c",
  null
  
)

export default component.exports